import { LoadingState, getDefaultLoadingState } from '@navix/shared/loading'
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity'
import { DisputeReasonGroup } from '../../domain/dispute-reason-groups/dispute-reason-group.model'
import { DisputeReasonGroupAsyncOperations } from '../../domain/dispute-reason-groups/dispute-reasons-loading.model'

// State + adapter live in their own leaf module (importing no child reducers)
// so the per-action reducer files can depend on them without creating a
// circular import back through dispute-reason-groups.reducer.ts.

export const disputeReasonGroupsAdapter: EntityAdapter<DisputeReasonGroup> =
  createEntityAdapter<DisputeReasonGroup>()

export const DISPUTE_REASON_GROUPS_FEATURE_KEY = 'feature-dispute-reason-groups'

export interface DisputeReasonGroupsState
  extends EntityState<DisputeReasonGroup> {
  loading: LoadingState<typeof DisputeReasonGroupAsyncOperations>
}

export const initialDisputeReasonGroupsState: DisputeReasonGroupsState =
  disputeReasonGroupsAdapter.getInitialState({
    loading: getDefaultLoadingState(DisputeReasonGroupAsyncOperations)
  })
